module.exports = __webpack_public_path__ + "static/media/default-user-banner.3037e648.jpg";